import ApiBase from '../api-base'
import { ACTIVE_BASE_REST } from '../constants'
export default class GatewatEmail extends ApiBase {
  constructor(store) {
    const path = ACTIVE_BASE_REST + '/gateway/email'
    super(store, path)
  }
}
